import { iHolidayQuoteItineraryBlock } from "@/@sdk/holiday-quotes-x/holiday-quotes-x-model";
import { GlobalConfig } from "@/config";

const HOTEL_PHOTO_REFERENCES = [
  "AWCwydjdup7awz0-3v2b5nvGBMcuucl-yji0HEi-orUOXK-zAxqs9YZ0t2wSFTN9ZEAdNnlJKnzI0-jxS6hC95cZQMZmU9sK1lykozA17PuD8Wr-Fe5oewog-K-ys75b8FjigMHPmU58iHDcmNsCS8hx8udna1s8tgsTZgC_YBGStbgva2663VDMQO0N1-cguhRtdEGmbktBC2Hsjgwu0mlq3aIOMGiv-bZSIu-jeU6INQgXhPS7rZtW5B6qtm9vOybmtj5juNHyXpm2QvSaJUJub0hZ0FpupVnguQ2oIODrkrd3v-9wTsjidi8wAtvvM5SQwnxAkL7sDAnkM7CXSbhMoG1Kn13YPF0bnZCZnNjgBWmAPkM_YABema6p_Nlyk6JxdDnF8iBFZRcvGcf_mPo_uHP5Cl4KgBZm5lJB93BMBu4JIhVfMEbcaHR3-YByoZEQ",
  "AWCwydgU41UV-yNxYC7KZwsw5D8w1eqt3t_9JHKU_nwS2KkBA6BCpBCUCR3U1ilvJZaNg9eco73-GPAuJ6FrGtigyCsjaofHfRNOSsK6b63Ny-yxXkQLvxQxRx0Zsc3dn-XGc2Fc0G90g6731Jgq6QuFhdSGV1QK-qIcyzx2fP6Yw88va4JtorKlU16FaJSLRrmmbWVvGktymMqIAv5PtPxvLOX3WtA_NBiWGe5CZi3KwHfC6wfw-5s-sPI7P6-hjdMbZyxByRis6g3wO3DGXQMcpQHZb7JrglOJulq54RuL-kmyrJudBHx4BL3X9oRhh9NV5Ikew3DYsPs0S31HSSc6kpbEgZpkAVwY77J9rmr9HOjZLGNTPrQqXqcXuS12h54mX9qSgnrBr2826MYFDFZO-E0DKdz9M4q2IhgSdzgeHqDfY2KL",
  "AWCwydgoK2OgDuMCpQl39-LdcnL_4VoH-AdnepjCf-uFQuC-ZQgsi9RavEXdIqjjQ7GLDWRO_lRJm9hyi0N3EuEYTDGdqF5Ech-WmE58OJ-u2SDnjTdt7zTE0takeToeLRVLofvqY6mvSDLd3Hn34Y79ZHAYIcAe5kWUpW2D4cTy6RGEc1F395G88Wgoqf_ppxDud023BRwHS5jmVSNX_5jTZUdbg-U_K3sHnW3YYpcXx_-n70nuJY2hLw6hH-3UxDs-0CQac2p9yvtnOPpEQAZqbU9ktQtdRdchSXA3YFoK0GBg9hnUYy2zQJv55wixxdUycJXSdOsUVh75ZCZVWgC3feZTsWD3ZC6f78Ar_f1kwpQLGiQGuIAHEfibpAgCRkpglZ23GhsQ1RdqrU044NZSOkkes2dUIoP92xNwdsyAKEbBS3IBKrD9QwtxP5vQ-Q20",
  "AWCwydglM6k1zLLfdq8l0Aji-HHYxoA_ZKteGvonJUArfUulfZGWYH970nnbTSBSRBxnBqKeZ9Ry0b9Q2O2xQrblCkAM3fIPbrcYOc9SrNxPH_pU5x2TVPKdQOgR5sUh9tQJAJk_fM4EVPA5EdovyqDvB7Jye2FmGNY8JOA1qbi5PEQ9bV6x364VfS419Ls2-iwTbRAjdTqH2xMusMZT6iT46qpIIHZv3BzBmWd2wagYyBzYWXyW2qBVJQB2oU5P_8h2Nc-L_xHxHO8RiATLcrv5Er-o2zVjMl9FXgzS4QdRE-3mcvudbu_JZIWD6eKp7zKPUnR1E1QmoSkMFhTRz3OsXsvSpsrg8J6ib51z1F3QhrC5LuoHGK1aQ8rQlkNUrG49waeB7Cu2MdqHIXPDUCdZh91z_-edA32ZeVSFbo8txUs",
  "AWCwydjy3TlGEax_NHMIYCv_LvOWnCfonTrwI-9qD2ZIK07Fi9KY7b54uZU0uMA8WkgtASLlksZ8xu-Cr5XAmGJ7CUqi1WFLE-B0bNnXlOxhSc-0MBm3T1gwgIGIvOydIiuJnvyeEhBSOmTHxMxiYNFTjrHh6jBQBGkr9OKxm9JqNIw1_omNIxJuYQ-g8-qRqt-2nLLgDbXS7_zyPJ88OLKnC1qChLP64QZB9NV1FE6pe-vhVmm32X8dWPytlMYxzb9zBNeXuaNsw8MFqUF3x1_faSMOmY03_XOY5RC4yTICCPog9IiNCV194eCOn2MAYJul-u4IvEFl_1FKopXv7RRHVU25sMepi_FmNSVPvHfeYnev5VirYUHATIOajNiedKYfR8Bgh3QAecpGoujD3tAneNr0PgMuz2djaAvbDUMaEn-FRonsfJO1MWg3BJfGJQ",
  "AWCwydh1FOPmqbmtH6ITaQlof2IOTLMq3uXAQqPbZDv6EskXQ7kQxHQci1lJUj_pP_ZusszKckpOXa8UmiBUyZ9PaURTbQ0XS-eRNawDCqgJIIFwg18aNcNqs3zABRkc-uhwu5tbR0zQ2qpJd_whIsCaIYI1jLsuNl2YbOsmTehznQiNb44Sl-mDsRlhHqwRwPwnXlzDDh6e3qrYemU88buGYX-jV3VbX1LL3n3RMnw2_Aj15RtLfDGeLRQPy13nO5cFMuhtLomiFTojciP82E4CZ4bhM91y99xyR_49xaB_yR6BKso5Gc2bTngLW6x04N-Tm8L1bJgwlWtqrN0_UJpiQuPRx5sHD9yTzf0Aa1At-Vj6Uo_s6jATfLKlEa-A9AjqHxri4ajcJ4p3Tk9YY7eBKFlmhy_26m6MmXH2wivF3Rzd-sA8ruifKVI5Nz_NOCDs",
];

function locationPhotoUrl(photoReference: string): string {
  return `${GlobalConfig.ENGINE_BASE_PATH}/location/photos?photoReference=${encodeURIComponent(photoReference)}`;
}

export function buildPreviewHotelBlock(): iHolidayQuoteItineraryBlock {
  return {
    id: "preview-hotel",
    type: "hotel",
    accommodationData: {
      title: "Hotel Stay",
      icon: "hotel",
      accommodationName: "Sheraton Maldives Full Moon Resort & Spa",
      rooms: [
        {
          id: "preview-room",
          roomType: "Sunset Overwater Villa",
          boardBasis: "All Inclusive",
          checkInDate: "2026-09-12",
          checkInTime: "14:00",
          checkOutDate: "2026-09-22",
          checkOutTime: "11:00",
        },
      ],
      overview: `Escape to a private island paradise in the North Malé Atoll. The Sheraton Maldives Full Moon Resort & Spa offers lush tropical gardens, white-sand beaches, and iconic overwater villas with direct lagoon access.

Enjoy world-class dining across multiple restaurants and bars, a full-service spa, and exceptional snorkelling right from the reef. The resort's all-inclusive programme covers meals, drinks, and a wide range of activities — making it the perfect setting for a romantic honeymoon.

Highlights:
• Sunset Overwater Villa with private deck and lagoon access
• All-inclusive dining and premium beverages
• House reef snorkelling and water sports
• 45-minute speedboat transfer from Malé International Airport`,
      place: {
        address_components: [
          {
            long_name: "Furanafushi Island North Malé Atol",
            short_name: "",
            types: [],
          },
          {
            long_name: "Maldives",
            short_name: "MV",
            types: ["country", "political"],
          },
          {
            long_name: "Kaafu Atoll",
            short_name: "Kaafu Atoll",
            types: ["administrative_area_level_2", "political"],
          },
          {
            long_name: "08240",
            short_name: "08240",
            types: ["postal_code"],
          },
        ],
        adr_address:
          'Furanafushi Island North Malé Atol, <span class="postal-code">08240</span>, <span class="country-name">Maldives</span>',
        business_status: "OPERATIONAL",
        editorial_summary: {
          language: "en",
          overview:
            "High-end beach resort featuring multiple eateries & bars, plus a dive center & a pool.",
        },
        formatted_address:
          "Furanafushi Island North Malé Atol, 08240, Maldives",
        formatted_phone_number: "664-2010",
        geometry: {
          location: { lat: 4.2505966, lng: 73.5462671 },
          viewport: {
            northeast: { lat: 4.2519455802915, lng: 73.5476160802915 },
            southwest: { lat: 4.2492476197085, lng: 73.5449181197085 },
          },
        },
        icon: "https://maps.gstatic.com/mapfiles/place_api/icons/v1/png_71/lodging-71.png",
        icon_background_color: "#909CE1",
        icon_mask_base_uri:
          "https://maps.gstatic.com/mapfiles/place_api/icons/v2/hotel_pinlet",
        international_phone_number: "+960 664-2010",
        name: "Sheraton Maldives Full Moon Resort & Spa",
        photos: HOTEL_PHOTO_REFERENCES.map((photo_reference) => ({
          height: 960,
          width: 1440,
          html_attributions: [
            '<a href="https://maps.google.com/maps/contrib/111357368467645195966">Sheraton Maldives Full Moon Resort &amp; Spa</a>',
          ],
          photo_reference,
        })),
        place_id: "ChIJTxp145qBPzsRa4JXAwhkbrc",
        plus_code: {
          compound_code: "7G2W+6G Malé, Maldives",
          global_code: "6JPM7G2W+6G",
        },
        rating: 4.5,
        reference: "ChIJTxp145qBPzsRa4JXAwhkbrc",
        reviews: [
          {
            author_name: "Tala",
            rating: 5,
            relative_time_description: "a month ago",
            text: "Wonderful Island Paradise with Exceptional Hospitality. The island is lush and beautifully maintained, with crystal-clear water, white sandy beaches, and a relaxed atmosphere that makes it easy to unwind.",
            time: 1780350003,
          },
        ],
        types: ["establishment", "lodging", "point_of_interest"],
        url: "https://maps.google.com/?cid=13217611941957567083",
        user_ratings_total: 1747,
        utc_offset: 300,
        vicinity: "Furanafushi Island North Malé Atol",
        website:
          "https://www.marriott.com/en-us/hotels/mlesi-sheraton-maldives-full-moon-resort-and-spa/overview/",
        wheelchair_accessible_entrance: true,
      },
      images: HOTEL_PHOTO_REFERENCES.map(locationPhotoUrl),
    },
  };
}
